import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';

import { ROUTE_PATHS } from 'shared/consts/routes';

import { HeaderPair } from '../HeaderPair';
import { HeaderProject } from '../HeaderProject/HeaderProject';

const PageHeaderPiece: React.FC = () => {
  const { pathname } = useLocation();
  const [headerType, setHeaderType] = useState<'header-project' | 'header-pair' | null>(null);

  useEffect(() => {
    const changeHeaderTypeRelateToPathname = () => {
      const matchDexPair = matchPath({ path: ROUTE_PATHS.dexPair }, pathname);
      const matchSolPair = matchPath({ path: ROUTE_PATHS.solPair }, pathname);
      const matchCexPair = matchPath({ path: ROUTE_PATHS.cexPair }, pathname);
      const matchPair = matchPath({ path: ROUTE_PATHS.pair }, pathname);

      if (matchPath({ path: ROUTE_PATHS.project }, pathname)) {
        return setHeaderType('header-project');
      }
      if (
        matchDexPair ||
        matchCexPair ||
        matchSolPair ||
        (matchPair && pathname.includes('cex')) ||
        (matchPair && pathname.includes('dex')) ||
        (matchPair && pathname.includes('sol'))
      ) {
        return setHeaderType('header-pair');
      }

      return setHeaderType(null);
    };

    changeHeaderTypeRelateToPathname();
  }, [pathname]);
  return (
    <>
      {headerType === 'header-project' && <HeaderProject />}
      {headerType === 'header-pair' && <HeaderPair />}
    </>
  );
};

export { PageHeaderPiece };
